import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { Sidebar, SIDEBAR_WIDTH } from "./Sidebar";
import { Topbar } from "./Topbar";
import { useAuth } from "@/auth/useAuth";
import { navAllowed } from "@/auth/nav";

export function AppLayout() {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const mobileItems = user ? navAllowed(user.role, user.permissions).slice(0, 5) : [];

  return (
    <Box display="flex" minHeight="100vh" bgcolor="background.default">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <Box component="main" flexGrow={1} sx={{ width: { md: `calc(100% - ${SIDEBAR_WIDTH}px)` } }}>
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        <Box className="crm-content">
          <Outlet />
        </Box>
      </Box>
      <BottomNavigation className="crm-mobile-nav" sx={{ bottom: 0, display: { md: "none" }, left: 0, position: "fixed", right: 0, zIndex: 20 }}>
        {mobileItems.map((item) => (
          <BottomNavigationAction key={item.path} component={NavLink} to={item.path} end={item.path === "/"} label={item.label} icon={<item.icon />} />
        ))}
      </BottomNavigation>
    </Box>
  );
}
